import { environment } from '@environments/environment';

export const GET_FILTER_PAGES_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_sem ?? '',
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
      },
    },
    _source: ['url', 'title', 'visuel'],
  },
});
